import { EmailSignaturePreference } from 'mini-bx-user-custom-properties';

let emailSignatureCache: EmailSignaturePreference;
let emailSignaturePreferenceItemIdCache: string;

export const storeEmailSignaturePreferenceInCache = (
    emailSignature: EmailSignaturePreference
): EmailSignaturePreference => (emailSignatureCache = emailSignature);

export const getEmailSignaturePreferenceFromCache = (): EmailSignaturePreference =>
    emailSignatureCache;

export const isEmailSignaturePreferenceInCache = (): boolean => !!emailSignatureCache;

export const storeEmailSignaturePreferenceItemIdInCache = (itemId: string): string =>
    (emailSignaturePreferenceItemIdCache = itemId);

export const getEmailSignaturePreferenceItemIdFromCache = (): string =>
    emailSignaturePreferenceItemIdCache;
